// extracted by mini-css-extract-plugin
export var content = "FFFErrorBoundary_content__26oDT";
export var errorPage = "FFFErrorBoundary_errorPage__y7SjB";
export var imageWrapper = "FFFErrorBoundary_imageWrapper__pnMt5";
export var lg = "992px";
export var md = "768px";
export var separator = "FFFErrorBoundary_separator__iVnqf";
export var shared = "'../shared.module.css'";